module.exports = __webpack_public_path__ + "img/nav-design-halfsize@2x.867725a.jpg";